<div [className]="'image-content-block ' + imgAlign">
  <div class="image-content-block__content">
   <ng-content></ng-content>
  </div>
  <div [className]="'image-content-block__image ' + imgAlign">
    <img *ngIf="imgSrc" [src]="imgSrc" alt="img">
    <div *ngIf="svgSrc" class="svg" [inlineSVG]="svgSrc"></div>
  </div>
</div>
